export function VerifyPermission(user, { modulo, submodulo, funcao }) {
    if (user?.IS_ADMIN) return true;
    if (!user?.PERMISSIONS?.length) return false;

    return user.PERMISSIONS.some(
        p =>
            (!modulo || p.modulo === modulo) &&
            (!submodulo || p.submodulo === submodulo) &&
            (!funcao || p.funcao === funcao)
    );
}

/** Retorna true se o usuário tiver ao menos uma das permissões informadas. */
export function VerifyAnyPermission(user, permissions = []) {
    if (user?.IS_ADMIN) return true;
    if (!Array.isArray(permissions) || permissions.length === 0) return false;
    return permissions.some((permission) => VerifyPermission(user, permission));
}